export var getCurrentPosition = function getCurrentPosition(wrapperRef, tabsWidth, blurOffset) {
  var _ref = wrapperRef.current || {},
    _ref$scrollLeft = _ref.scrollLeft,
    scrollLeft = _ref$scrollLeft === void 0 ? 0 : _ref$scrollLeft,
    _ref$offsetWidth = _ref.offsetWidth,
    offsetWidth = _ref$offsetWidth === void 0 ? 0 : _ref$offsetWidth;
  var startIndex = -1;
  var endIndex = -1;
  var currentWidth = 0;
  var leftOffset = scrollLeft + ((blurOffset === null || blurOffset === void 0 ? void 0 : blurOffset.left) || 0) * 0.33;
  var rightOffset = scrollLeft + offsetWidth - ((blurOffset === null || blurOffset === void 0 ? void 0 : blurOffset.right) || 0) * 0.33;
  tabsWidth.forEach(function (width, i) {
    if (currentWidth > leftOffset && startIndex === -1) {
      startIndex = i;
    }
    if (currentWidth < rightOffset) {
      endIndex = i;
    }
    currentWidth += width;
  });
  return {
    left: startIndex === -1 ? 0 : startIndex,
    right: endIndex === -1 ? tabsWidth.length - 1 : endIndex
  };
};
export var getTargetScrollPosition = function getTargetScrollPosition(targetIndex, tabsWidth, side, wrapperRef, blurOffset) {
  var _ref2 = wrapperRef.current || {},
    _ref2$offsetWidth = _ref2.offsetWidth,
    offsetWidth = _ref2$offsetWidth === void 0 ? 0 : _ref2$offsetWidth,
    _ref2$scrollWidth = _ref2.scrollWidth,
    scrollWidth = _ref2$scrollWidth === void 0 ? 0 : _ref2$scrollWidth;
  var size = tabsWidth.slice(0, targetIndex).reduce(function (acc, v) {
    return acc + v;
  }, 0);
  if (side === 'left') {
    var _position = size - ((blurOffset === null || blurOffset === void 0 ? void 0 : blurOffset.left) || 0) * 0.66;
    return _position < 100 ? 0 : _position;
  }
  var position = size - offsetWidth + 6 + ((blurOffset === null || blurOffset === void 0 ? void 0 : blurOffset.right) || 0) * 0.66;
  return scrollWidth - offsetWidth - 100 < position ? scrollWidth : position;
};